import { createSlice, createAsyncThunk } from "@reduxjs/toolkit";
import { notification } from "antd";
import axios from "./apiAxios.js";

export const createJob = createAsyncThunk(
	"job/create",
	async ({ values, silent = false }, { rejectWithValue }) => {
		try {
			const { data } = await axios.post(`/admin/job/create`, values);
			if (!silent) {
				notification.success({
					message: "Success",
					description: "Job item succesfully created.",
					duration: 3,
				});
			}
			return data;
		} catch (err) {
			if (!silent) {
				notification.error({
					message: "Error",
					description: err.response.data.message,
					duration: 3,
				});
			}
			return rejectWithValue(err.response.data.message);
		}
	}
);

export const fetchJobs = createAsyncThunk(
	"jobs/fetch",
	async (_, { rejectWithValue }) => {
		try {
			const { data } = await axios.get(`/admin/jobs/fetch`);
			return data;
		} catch (err) {
			notification.error({
				message: "Error",
				description: err.response.data.message,
				duration: 3,
			});
			return rejectWithValue(err.response.data.message);
		}
	}
);

export const deleteOfferedJobs = createAsyncThunk(
	"jobs/deleteOffered",
	async (id, { rejectWithValue }) => {
		try {
			const { data } = await axios.delete(`/admin/job/delete/offeredjobs/${id}`);
			return data;
		} catch (err) {
			notification.error({
				message: "Error",
				description: err.response.data.message,
				duration: 3,
			});
			return rejectWithValue(err.response.data.message);
		}
	}
);

export const jobsSlice = createSlice({
	name: "jobs",
	initialState: {
		loading: false,
		jobs: [],
		error: null,
	},
	extraReducers: {
		//create Trade
		[createJob.pending]: (state) => {
			state.loading = true;
		},
		[createJob.fulfilled]: (state, { payload }) => {
			state.jobs = [...state.jobs, payload];
			state.loading = false;
		},
		[createJob.rejected]: (state, { payload }) => {
			state.error = payload;
			state.loading = false;
		},
		[deleteOfferedJobs.pending]: (state) => {
			state.loading = true;
		},
		[deleteOfferedJobs.fulfilled]: (state, { payload }) => {
			state.jobs = state.jobs.filter((job) => job._id !== payload.data._id);
			state.loading = false;
		},
		[deleteOfferedJobs.rejected]: (state, { payload }) => {
			state.error = payload?.message;
			state.loading = false;
		},

		//Fetch Trades
		[fetchJobs.pending]: (state) => {
			state.loading = true;
		},
		[fetchJobs.fulfilled]: (state, { payload }) => {
			state.jobs = payload;
			state.loading = false;
		},
		[fetchJobs.rejected]: (state, { payload }) => {
			state.error = payload;
			state.loading = false;
		},
	},
});

// Action creators are generated for each case reducer function

export const { authenticate } = jobsSlice.actions;

export default jobsSlice.reducer;
